import { GridColumn } from 'src/components/GridWrapper';
import DocumentNumberCell from 'src/sections/po_related_documents/documents_grid/DocumentNumberCell';
import LinkedDocument from 'src/sections/po_related_documents/documents_grid/LinkedDocument';

const specificStyle = (field: string, value: any) => ({
  color: Number(value[field]) < 0 ? '#D9534F' : '',
});

export const poVarianceColumns: GridColumn<any>[] = [
  {
    field: 'documentNumber',
    title: 'Related Documents#',
    filter: 'text',
    dataType: 'string',
    component: DocumentNumberCell,
  },
  {
    field: 'documentType',
    title: 'Doc Type',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'linkedDocumentId',
    title: 'Linked Document',
    filter: 'numeric',
    dataType: 'number',
    component: LinkedDocument,
    width: 300,
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'documentQuantity',
    title: 'Doc Qty',
    filter: 'numeric',
    dataType: 'number',
    specificStyle,
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'documentTotal',
    title: 'Doc Total',
    filter: 'numeric',
    format: '{0:c2}',
    dataType: 'dollar',
    specificStyle,
    filterFormat: 'c2',
  },
  {
    field: 'status',
    title: 'Status/History',
    filter: 'text',
    format: '',
    dataType: 'string',
  },
  {
    field: 'statusDate',
    title: 'Status Date',
    filter: 'date',
    format: '{0:MM/dd/yyyy}',
    dataType: 'date',
  },
  {
    field: 'poTotal',
    title: 'PO Total',
    filter: 'numeric',
    format: '{0:c2}',
    dataType: 'dollar',
    specificStyle,
    filterFormat: 'c2',
  },
];

export default poVarianceColumns;
